import { apiClient } from './api-client';
import {
  themeImportHistoryResponseSchema,
  themeImportQuestionsResponseSchema,
} from './theme-import-history.contract';

export const themeImportHistoryQueryKey = ['theme-import-history'] as const;

export type ThemeImportStatusFilter = 'active' | 'inactive';

export interface ThemeImportHistoryParams {
  cursor: string | null;
  limit?: number;
  sector?: string | null;
  status?: ThemeImportStatusFilter | null;
  search?: string | null;
}

export async function getThemeImportHistory(params: ThemeImportHistoryParams) {
  const { cursor, limit = 20, sector, status, search } = params;
  const response = await apiClient.get('/themes/admin/imports', {
    params: {
      limit,
      ...(cursor ? { cursor } : {}),
      ...(sector ? { sector } : {}),
      ...(status ? { status } : {}),
      ...(search ? { search } : {}),
    },
  });
  return themeImportHistoryResponseSchema.parse(response.data);
}

export interface ThemeImportQuestionsParams {
  page?: number;
  limit?: number;
  status?: ThemeImportStatusFilter;
}

export async function getThemeImportQuestions(
  themeId: string,
  { page = 1, limit = 100, status = 'active' }: ThemeImportQuestionsParams = {},
) {
  const response = await apiClient.get(`/themes/admin/imports/${themeId}/questions`, {
    params: { page, limit, status },
  });
  return themeImportQuestionsResponseSchema.parse(response.data);
}
